<div *transloco="let transloco" class="flex">
  <p-multiSelect
    (onChange)="this.props.change && this.props.change(field, $event)"
    [formControl]="this.formControl"
    [formlyAttributes]="this.field"
    [ngClass]="{
      'ng-dirty ng-invalid p-invalid': this.showError
    }"
    [optionGroupChildren]="this.props.groupChildrenProp || 'group'"
    [optionGroupLabel]="this.props.groupLabelProp || 'label'"
    [filterBy]="'searchText'"
    [options]="
      (this.props.options | formlySelectOptions: this.field | async)!
        | libSelectSearchText
          : undefined
          : undefined
          : this.props.groupChildrenProp
          : this.props.searchByValue
    "
    [placeholder]="transloco(this.props.placeholder || '') || '&nbsp;'"
    [readonly]="this.props.readonly"
    [scrollHeight]="this.props.scrollHeight || '500px'"
    [showClear]="this.props.readonly == undefined ? this.props.showClear : !this.props.readonly"
    [optionLabel]="this.props.optionLabel || 'label'"
    [optionValue]="this.props.optionValue || 'value'"
    [virtualScrollItemSize]="this.props.virtualScrollSize"
    [virtualScroll]="this.props.virtualScroll"
    appendTo="body"
    class="w-full"
    fluid>
    <ng-template let-item #item>
      {{ transloco(item['label']) }}
    </ng-template>
    <ng-template let-selectedItems #selecteditems>
      <div class="inline-grid">
        @if (selectedItems?.length) {
          <span class="truncate">
            @for (selectedItem of selectedItems; track selectedItem; let index = $index) {
              {{ transloco(selectedItem['label'])
              }}{{ selectedItems.length === index + 1 ? '' : ',' }}
            }
          </span>
        }
      </div>
    </ng-template>
  </p-multiSelect>
</div>
